class BeforeAfterSlider {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.after = wrapper.querySelector('.before-after__after');
    this.handle = wrapper.querySelector('.before-after__handle');
    this.isDragging = false;

    this.setWrapperWidth();
    this.bindEvents();
  }

  setWrapperWidth() {
    this.wrapper.style.setProperty('--wrapper-width', this.wrapper.offsetWidth + 'px');
  }

  getPositionPercent(clientX) {
    const rect = this.wrapper.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    return Math.min(Math.max(pct, 2), 98);
  }

  setPosition(pct) {
    this.after.style.width = pct + '%';
    this.handle.style.left = pct + '%';
    this.handle.setAttribute('aria-valuenow', Math.round(pct));
  }

  bindEvents() {
    // Mouse
    this.wrapper.addEventListener('mousedown', (e) => {
      this.isDragging = true;
      this.wrapper.classList.add('is-dragging');
      this.setPosition(this.getPositionPercent(e.clientX));
    });

    window.addEventListener('mousemove', (e) => {
      if (!this.isDragging) return;
      this.setPosition(this.getPositionPercent(e.clientX));
    });

    window.addEventListener('mouseup', () => {
      this.isDragging = false;
      this.wrapper.classList.remove('is-dragging');
    });

    // Touch
    this.wrapper.addEventListener('touchstart', (e) => {
      this.isDragging = true;
      this.wrapper.classList.add('is-dragging');
      this.setPosition(this.getPositionPercent(e.touches[0].clientX));
    }, { passive: true });

    window.addEventListener('touchmove', (e) => {
      if (!this.isDragging) return;
      this.setPosition(this.getPositionPercent(e.touches[0].clientX));
    }, { passive: true });

    window.addEventListener('touchend', () => {
      this.isDragging = false;
      this.wrapper.classList.remove('is-dragging');
    });

    // Teclado (accesibilidad)
    this.handle.addEventListener('keydown', (e) => {
      const step = e.shiftKey ? 10 : 2;
      const current = parseFloat(this.handle.style.left);
      if (e.key === 'ArrowLeft') this.setPosition(Math.max(current - step, 2));
      if (e.key === 'ArrowRight') this.setPosition(Math.min(current + step, 98));
    });

    // Resize
    window.addEventListener('resize', () => {
      this.setWrapperWidth();
    });
  }
}

document.querySelectorAll('[id^="BeforeAfter-"]').forEach((el) => {
  new BeforeAfterSlider(el);
});
